export const PhotoLayerFeatureProperty = {
  ATTACHMENTS: 'attachments',
  CLUSTER_SIZE: 'count',
  LAYOUT: 'layout',
  ANIMATION_PROGRESS: 'animationProgress'
};
